module.exports = __webpack_public_path__ + "static/media/signupApple-black.en.658e5011.svg";